import React from 'react';
import { UserPasswordChangeTemplate } from 'themes/modules/user/pages';
import { UserPasswordChangeViewStore } from 'modules/user/stores';
import { setCurrentView } from 'core/utils';
import { observer } from 'mobx-react';

@setCurrentView(rootStore => new UserPasswordChangeViewStore(rootStore), 'userPasswordChangeViewStore')
@observer
class UserPasswordChange extends React.Component {
	render() {
		return <UserPasswordChangeTemplate {...this.props} />;
	}
}

export default UserPasswordChange;
